import { render, staticRenderFns } from "./Rastreia.vue?vue&type=template&id=07868627&"
import script from "./Rastreia.vue?vue&type=script&lang=js&"
export * from "./Rastreia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports